import { formatSurgeonsAndAssistants, formatSurgeonsAndAssistantsCombo, getSurgeryCategoryName } from '~/app/pages/WaitingList/shared/utils'
import { BarListItem } from '~/components/BarList'
import { CommonSurgery, useSurgeryTypeGroups } from '~/storm'
import { getSurgeryMetadata } from '~/utils/surgeryMetadata'

export const SURGERY_TYPE_GROUP_INCLUDES = { surgeryTypes: true, specialities: true, subgroups: true } as const

const transformToBarListItems = (
    surgeries: CommonSurgery[],
    surgeryToName: (surgery: CommonSurgery) => string,
    surgeryToTooltip?: (surgery: CommonSurgery) => string | undefined
) => {
    const sortedWaitingList = surgeries
        .map(item => ({
            name: surgeryToName(item),
            tooltip: surgeryToTooltip?.(item),
            cleared: getSurgeryMetadata(item)?.patient_ready ?? false,
        }))
        .toSorted((a, b) => a.name.localeCompare(b.name))

    return sortedWaitingList.reduce<BarListItem[]>((acc, item) => {
        const existing = acc.find(i => i.name === item.name)
        if (existing) {
            existing.total++
            if (item.cleared) {
                existing.actual++
            }
        } else {
            acc.push({
                name: item.name,
                tooltip: item.tooltip,
                total: 1,
                actual: item.cleared ? 1 : 0,
            })
        }
        return acc
    }, [])
}
export const useTransformToBarListItemBySurgeryCategory = (surgeries: CommonSurgery[]) => {
    const surgeryTypeGroups = useSurgeryTypeGroups({ include: SURGERY_TYPE_GROUP_INCLUDES })
    const surgeryToName = (surgery: CommonSurgery) => getSurgeryCategoryName(surgery, surgeryTypeGroups) ?? ''
    return transformToBarListItems(surgeries, surgeryToName)
}

export const useTransformToBarListItemBySurgeon = (surgeries: CommonSurgery[]) =>
    transformToBarListItems(
        surgeries,
        surgery => formatSurgeonsAndAssistantsCombo(surgery),
        surgery =>
            formatSurgeonsAndAssistants(surgery)
                .map(({ shortName, fullName }) => fullName ?? shortName)
                .join(' + ')
    )
